import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }:any) => {
  const token = localStorage.getItem("admin_token");

  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
